export default "__VITE_ASSET__5d69ed7c__"